import { render, staticRenderFns } from "./PsEventApply.vue?vue&type=template&id=bb1c8cd8&scoped=true&"
import script from "./PsEventApply.vue?vue&type=script&lang=js&"
export * from "./PsEventApply.vue?vue&type=script&lang=js&"
import style0 from "./PsEventApply.vue?vue&type=style&index=0&id=bb1c8cd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1c8cd8",
  null
  
)

export default component.exports